<style lang="scss" scoped>
@use 'sass:color';
@use '../../../palette.scss' as *;

.no-unit {
    display: flex;
    justify-content: center;

    .block {
        background-color: color.adjust($theme-grey, $alpha: -0.7);
        color: $theme-dark-grey;
        box-shadow: $major-shadow;
        border-radius: 10px;
        padding: 15px;
        font-size: 2em;
        margin: 0 15px;
    }
}
</style>

<template>
    <div>
        <UnitDataManager
            @removeSensor="removeSensor"
            :unit="unit"
            v-if="unit"
        />
        <div class="no-unit" v-else>
            <div class="block">{{ $t('noUnitData') }}</div>
        </div>
    </div>
</template>

<script>
import { changeMonitor } from '../../../api/ChangeMonitor';
import { getUnit } from '../../../api/units';
import UnitDataManager from './UnitDataManager.vue';
import { STATUS_OK } from '../../../api/client';

export default {
    name: 'UnitDetails',

    data() {
        return {
            nonLocalUnit: null,
            redirectBack: false,
        };
    },

    computed: {
        // Whether or not we are on the admin unit edit page or the more generic unit details page for
        //  the active unit on this campaign
        nonAdminView() {
            return !this.$route.params.unitId;
        },

        // Depending on the page we're on, we want to display the unit from state or from the server
        unit() {
            if (this.nonAdminView) {
                return this.$store.state.unitData;
            }

            return this.nonLocalUnit;
        },
    },

    watch: {
        $route(to, from) {
            // If we're on the admin view now, we need to update the unit data we have locally
            if (!this.nonAdminView) {
                this.nonLocalUnit = null;
                this.getUnitInformation();
            }
        },

        redirectBack(newVal) {
            if (newVal) {
                if (this.$route.redirectedFrom) {
                    // If Vue Router knows where we came from
                    this.$router.push(this.$route.redirectedFrom.fullPath);
                } else if (window.history.state.back) {
                    // Try browser history
                    this.$router.back();
                } else {
                    // Fallback route if no "caller"
                    this.$router.push('/dashboard');
                }
            }
        },
    },

    created: async function () {
        // If we're on the admin page, we need to populate the local data from the server
        if (!this.nonAdminView) {
            this.getUnitInformation();
        }

        // Set up a Notified User on the change monitor for the unit in question
        changeMonitor.addNotifiedUser(this.handleUnitChanges);
    },

    beforeDestroy() {
        changeMonitor.removeNotifiedUser(this.handleUnitChanges);
    },

    methods: {
        handleUnitChanges(changeRecord) {
            if (changeRecord.changeType === 'UNIT') {
                if (this.unit) {
                    if (changeRecord.data.id === this.unit.id) {
                        this.nonLocalUnit = changeRecord.data;
                    }
                }
            }
        },

        async getUnitInformation() {
            const response = await getUnit(this.$route.params.unitId);
            if (response.status === 'ERROR') {
                this.redirectBack = true;
            } else {
                if (response.status === STATUS_OK) {
                    this.nonLocalUnit = response.payload;
                } else {
                    this.nonLocalUnit = null;
                    if (response.msg) {
                        toastr.error(this.$t(response.msg, response.msg_data));
                    } else {
                        toastr.error(this.$t('problemLoadingUnit'));
                    }
                }
            }
        },

        removeSensor(sensorId) {
            const sensors = this.unit.sensors.map((s) => ({ ...s }));
            for (let i = 0; i < sensors.length; i++) {
                if (sensors[i].id === sensorId) {
                    if (this.nonAdminView) {
                        this.$store.commit('setUnitData', {
                            ...this.unit,
                            sensors: sensors
                                .slice(0, i)
                                .concat(sensors.slice(i + 1)),
                        });
                    } else {
                        this.nonLocalUnit = {
                            ...this.nonLocalUnit,
                            sensors: sensors
                                .slice(0, i)
                                .concat(sensors.slice(i + 1)),
                        };
                    }
                }
            }
        },
    },

    components: {
        UnitDataManager: UnitDataManager,
    },
};
</script>
